export default {"dropdownTrigger":"uzfDOG_dropdownTrigger","sm":"uzfDOG_sm","value":"uzfDOG_value","empty":"uzfDOG_empty",}